import Vue from 'vue';
import Vuex from 'vuex';

import jobsService from '@/api/jobs';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isMobile: false,
    isCovid: false,
    jobs: [],
  },
  getters: {
    isMobile: state => state.isMobile,
    isCovid: state => state.isCovid,
    jobs: state => state.jobs,
  },
  mutations: {
    setIsMobile(state, isMobile) {
      state.isMobile = isMobile;
    },
    setIsCovid(state, isCovid) {
      state.isCovid = isCovid;
    },
    setJobs(state, jobs) {
      state.jobs = jobs;
    },
  },
  actions: {
    fetchJobs: context => jobsService.fetchJobs()
      .then((response) => {
        context.commit('setJobs', response);
        return Promise.resolve(response);
      })
      .catch(error => Promise.reject(error)),
  },
  modules: {

  },
});
